module.exports = __webpack_public_path__ + "img/mobile-62.8350116a.png";